import React from "react";

export const AuthContext = React.createContext<{
  ssoHiddenIframeRef: React.MutableRefObject<HTMLIFrameElement | null>;
  status: "PENDING" | "COMPLETE";
}>({ ssoHiddenIframeRef: { current: null }, status: "PENDING" });
